// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Metadata about which protocol populated this DTA
 * @export
 * @interface DTADocumentContentProtocolSource
 */
export interface DTADocumentContentProtocolSource {
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentProtocolSource
     */
    populated_at?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentProtocolSource
     */
    protocol_id?: string;
    /**
     * 
     * @type {string}
     * @memberof DTADocumentContentProtocolSource
     */
    study_title?: string;
}

/**
 * Check if a given object implements the DTADocumentContentProtocolSource interface.
 */
export function instanceOfDTADocumentContentProtocolSource(value: object): value is DTADocumentContentProtocolSource {
    return true;
}

export function DTADocumentContentProtocolSourceFromJSON(json: any): DTADocumentContentProtocolSource {
    return DTADocumentContentProtocolSourceFromJSONTyped(json, false);
}

export function DTADocumentContentProtocolSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DTADocumentContentProtocolSource {
    if (json == null) {
        return json;
    }
    return {
        
        'populated_at': json['populated_at'] == null ? undefined : json['populated_at'],
        'protocol_id': json['protocol_id'] == null ? undefined : json['protocol_id'],
        'study_title': json['study_title'] == null ? undefined : json['study_title'],
    };
}

export function DTADocumentContentProtocolSourceToJSON(json: any): DTADocumentContentProtocolSource {
    return DTADocumentContentProtocolSourceToJSONTyped(json, false);
}

export function DTADocumentContentProtocolSourceToJSONTyped(value?: DTADocumentContentProtocolSource | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'populated_at': value['populated_at'],
        'protocol_id': value['protocol_id'],
        'study_title': value['study_title'],
    };
}
